var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValueChainRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8.07514C6.43335 7.73656 7.5 6.4489 7.5 4.91211C7.5 3.11718 6.04493 1.66211 4.25 1.66211C2.45507 1.66211 1 3.11718 1 4.91211C1 6.4489 2.06665 7.73656 3.5 8.07514V16.4121C3.5 18.4832 5.17893 20.1621 7.25 20.1621H11.3143L10.0947 21.3818C9.80178 21.6747 9.80178 22.1495 10.0947 22.4424C10.3876 22.7353 10.8624 22.7353 11.1553 22.4424L13.6553 19.9424C13.9482 19.6495 13.9482 19.1747 13.6553 18.8818L11.1553 16.3818C10.8624 16.0889 10.3876 16.0889 10.0947 16.3818C9.80178 16.6747 9.80178 17.1495 10.0947 17.4424L11.3143 18.6621H7.25C6.00736 18.6621 5 17.6547 5 16.4121V8.07514ZM4.25 6.66211C5.2165 6.66211 6 5.87861 6 4.91211C6 3.94561 5.2165 3.16211 4.25 3.16211C3.2835 3.16211 2.5 3.94561 2.5 4.91211C2.5 5.87861 3.2835 6.66211 4.25 6.66211Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9053 2.94244C14.1982 2.64955 14.1982 2.17467 13.9053 1.88178C13.6124 1.58889 13.1376 1.58889 12.8447 1.88178L10.3447 4.38178C10.0518 4.67467 10.0518 5.14955 10.3447 5.44244L12.8447 7.94244C13.1376 8.23533 13.6124 8.23533 13.9053 7.94244C14.1982 7.64955 14.1982 7.17467 13.9053 6.88178L12.6857 5.66211H16.75C17.9926 5.66211 19 6.66947 19 7.91211V16.2491C17.5667 16.5876 16.5 17.8753 16.5 19.4121C16.5 21.207 17.9551 22.6621 19.75 22.6621C21.5449 22.6621 23 21.207 23 19.4121C23 17.8753 21.9333 16.5876 20.5 16.2491V7.91211C20.5 5.84104 18.8211 4.16211 16.75 4.16211H12.6857L13.9053 2.94244ZM18 19.4121C18 18.4456 18.7835 17.6621 19.75 17.6621C20.7165 17.6621 21.5 18.4456 21.5 19.4121C21.5 20.3786 20.7165 21.1621 19.75 21.1621C18.7835 21.1621 18 20.3786 18 19.4121Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueChainRequest);
export default __webpack_public_path__ + "static/media/value-chain-request.c3e7ae8f4cfef2c6a1fad0aedcb185ba.svg";
export { ForwardRef as ReactComponent };